// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/es7.map.of.js
// module id = 281
// module chunks = 0